<template>
<DialogBox title="Sort Items" :settings="settings">
    <div class="pa-2">
        <ListList ref="list" :items="items" />

    </div>
</DialogBox>
</template>

<script>
import clipboard from 'clipboard-js'
import DataHelpers from '../helpers/DataHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import DateHelpers from '../helpers/DateHelpers'
import draggable from 'vuedraggable'
import NiceData from '../data/NiceData'
import OrderHelpers from '../helpers/OrderHelpers'
import DialogBox from '../ui-elements/DialogBox'
import ElementsStore from '../store/ElementsStore'
import StringHelpers from '../helpers/StringHelpers'
import { debug } from 'util'
import ContactHelpers from '../helpers/ContactHelpers'
import LoanHelpers from '../helpers/LoanHelpers'
import ListList from '../forms/lists/ListList'

export default {
    data() {
        return {
            lookupData: null
        }
    },
    components: {
        draggable,
        DialogBox,
        ListList,
    },
    
    props: {
        settings: Object,
    },

    computed: {

        items() {
            if(!this.lookupData)
                return []
            else
                return this.lookupData.map(o => {
                    return {text: o.path, value: o.value}
                })
        }

    },

    methods: {

        loadLookupData() {
            
            let ref = DataHelpers.getTenantRef().child('lookup').orderByChild('path')
            NiceData.fetchItemsFromFirebase(ref).then(data => {
                this.lookupData = data
            })
        },



    },

    created() {
        this.loadLookupData()
    
    },

    mounted() {
        
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// LookupDataDialog.vue?5d221a70